import { ENOPOrganType } from '../enums';

export const ORGAN_COLORS: Record<ENOPOrganType, string> = {
  Liver: '#AFFB74',
  Lungs: '#87C8FF',
  Heart: '#CC9AFD',
};
export const ORGAN_PROGRESS_COLORS: Record<ENOPOrganType, string> = {
  Liver: '#587E3A',
  Lungs: '#527A9C',
  Heart: '#8263A1',
};
export const ORGAN_SHAPES: Record<ENOPOrganType, string> = {
  Liver: 'rhombus',
  Lungs: 'square',
  Heart: 'circle',
};
